.container {
  display: flex;
  gap: 0.8rem;
}
